import React from 'react';
import './spinner.css';

const Spinner = () => {
   return <div className="loader">Loading</div>
}

export default Spinner;